class TrSearchTyping extends HTMLElement {
	selectors = {
		input: '[data-input]'
	};

	nameAttributes = {
		prefix: 'data-prefix',
		phrases: 'data-phrases',
		typeSpeed: 'data-type-speed',
		pauseTime: 'data-pause-time'
	};

	constructor() {
		super();
	}

	connectedCallback() {
		this.init();
	}

	init() {
		this.inputElement = this.querySelector(this.selectors.input);

		this.prefixText =
			this.getAttribute(this.nameAttributes.prefix) || 'Search for';
		this.phrases =
			JSON.parse(this.getAttribute(this.nameAttributes.phrases)) || [];

		this.phraseIndex = 0;
		this.charIndex = 0;
		this.isDeleting = false;

		this.initialTypeSpeed =
			Number(this.getAttribute(this.nameAttributes.typeSpeed)) || 100;
		this.pauseTime =
			Number(this.getAttribute(this.nameAttributes.pauseTime)) || 2000;

		this.typeSpeed = this.initialTypeSpeed;

		if (this.phrases.length > 0) {
			this.tick();
		}
	}

	tick() {
		const currentPhrase = this.phrases[this.phraseIndex];

		if (this.isDeleting) {
			this.charIndex--;
			this.typeSpeed = this.initialTypeSpeed / 2;
		} else {
			this.charIndex++;
			this.typeSpeed = this.initialTypeSpeed;
		}

		const displayText =
			this.prefixText + currentPhrase.substring(0, this.charIndex);

		this.inputElement.placeholder = displayText;

		if (!this.isDeleting && this.charIndex === currentPhrase.length) {
			this.isDeleting = true;
			this.typeSpeed = this.pauseTime;
		} else if (this.isDeleting && this.charIndex === 0) {
			this.isDeleting = false;
			this.phraseIndex = (this.phraseIndex + 1) % this.phrases.length;
			this.typeSpeed = this.initialTypeSpeed * 2;
		}

		setTimeout(() => this.tick(), this.typeSpeed);
	}
}

customElements.define('tr-search-typing', TrSearchTyping);
